var _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCampaignBottomRibbon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 60,
    viewBox: "0 0 138 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122 59.9297C130.837 59.9297 138 52.7662 138 43.9297L138 0.000778198C138 0.000778198 135.612 11.6027 118.417 11.6027H-1.52588e-05L18 35.4258L0 59.9297H122Z",
    fill: "#E22837"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122 59.9297C130.837 59.9297 138 52.7662 138 43.9297L138 0.000778198C138 0.000778198 135.612 11.6027 118.417 11.6027H-1.52588e-05L18 35.4258L0 59.9297H122Z",
    fill: "url(#paint0_linear_10839_9147)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10839_9147",
    x1: 9.03569,
    y1: 72.9287,
    x2: 156.336,
    y2: 45.7933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395417,
    stopColor: "#D80213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.987065,
    stopColor: "#FF5757"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignBottomRibbon);
export default __webpack_public_path__ + "static/media/campaignBottomRibbon.e2d9ac238dbc6a38f7f855ed7ea4f57a.svg";
export { ForwardRef as ReactComponent };